import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  apiBaseUrl: string;
  // private apiBaseUrl: string = environment.apiBaseUrl;
  // private apiBaseUrl: string = 'https://rossap-albpu-inczsbvqt387-123829850.eu-central-1.elb.amazonaws.com';
  constructor(private http: HttpClient,private oauth: OAuthService) {
    this.apiBaseUrl = environment.isB2D
      ? environment.b2d.serverURL
      : environment.b2e.serverURL;
    console.log('this.apiBaseUrl', this.apiBaseUrl);
  }

  getVCDTableData(payload: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/getDataForInventorySelected`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${this.oauth.getAccessToken()}`,
        },
      }
    );
  }

  getNationalScreenData(payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/getDataForICDDealer`, payload, {
      headers: {
        Authorization: `Bearer ${this.oauth.getAccessToken()}`,
      },
    });
  }

  getRemovedVehiclesDealerInventoryData(payload: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/getRemovedVehiclesDealerInventoryData`,
      payload,
    {
      headers: {
        Authorization: `Bearer ${this.oauth.getAccessToken()}`,
      },
    }
    );
  }

  getDownloadFiles(payload: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/exportInventoryDataToPDFAndCSV`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${this.oauth.getAccessToken()}`,
        },
      }
    );
  }

  // getCenterInfo(payload: any): Observable<any> {
  //   return this.http.post(`${this.apiBaseUrl}/getCenterOrDealerInfo`, payload);
  // }
  getCenterInfo(payload:any): Observable<any> {
  return this.http.post(
    `${this.apiBaseUrl}/getCenterOrDealerInfo`,
    {
      centerId: payload.centerID,
      userType: environment.isB2D ? 'd' : 'e',
    },
    {
      headers: {
        Authorization: `Bearer ${this.oauth.getAccessToken()}`,
      },
    }
  );
}

  getSelectedFilterData(payload: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/getSelctedFiltersData`, payload,
      {
      headers: {
        Authorization: `Bearer ${this.oauth.getAccessToken()}`,
        },
      }
    );
    
  }

  // getB2DCenterInfo(centerId: string): Observable<any> {
  //   return this.http.post(`${this.apiBaseUrl}/getCenterId/${centerId}`, {});
  // }
  getB2DCenterInfo(centerId: string): Observable<any> {
  return this.http.post(
    `${this.apiBaseUrl}/getCenterId/${centerId}`,
    {
      userType: environment.isB2D ? 'd' : 'e',
    },
    {
      headers: {
        Authorization: `Bearer ${this.oauth.getAccessToken()}`,
      },
    }
  );
}
}
